import React from 'react'

import './Node.css'

function Node(props) {
    const {
        column,
        isFinish,
        isStart,
        isWall,
        onMouseDown,
        onMouseEnter,
        onMouseUp,
        row,
    } = props;

    const setClassName = 
        isFinish
        ? 'node-finish'
        : isStart
        ? 'node-start'
        : isWall
        ? 'node-wall'
        : '';

    return (
        <div 
        id={`node-${row}-${column}`}
        className={`node ${setClassName}`}
        onMouseDown={() => onMouseDown(row, column)}
        onMouseEnter={() => onMouseEnter(row, column)}
        onMouseUp={() => onMouseUp()}
        />
    )
}

export default Node;

